//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vueFilter from "@/common/filter/vuefilter.js";
export default {
  name: "servicePersonList",
  data() {
    return {
      initData: [],
      isLoading: false
    };
  },
  created(){
    // 监听安卓返回键
    this.setRouteListeners("servicePersonListGoBack");
    this.$root.$eventHub.$on("servicePersonListGoBack", data => {
      this.servicePersonListGoBack();
      this.$root.$eventHub.$off("servicePersonListGoBack"); //解绑当前监听，否则下轮监听还会持续叠加
    });
  },
  mounted() {
    this.getInitData();
  },
  methods: {
     servicePersonListGoBack() {
      this.removeRouteListeners("servicePersonListGoBack");
      //刷新页面
      var sendData = JSON.stringify({ handle: "reload_event_detail" });
      this.iJsBridge.call({
        method: "SMGeneral.setResultToNative",
        postData: sendData
      });
      this.iJsBridge.close();
    },
    async getInitData() {
      let params = {
        Filters: {
          MiceId:this.iStorage.get('eventData').proposalId
          // MiceId: "063599f0-5deb-464f-ad3e-ab93b2b46d7e"
        }
      };
      const res = await this.axios.post(this.api.QueryMiceWorkers, params);
      if (res.success) {
        this.isLoading=false;
        this.initData = res.content;
        this.initData.forEach((item, index) => {
          item.startDate = vueFilter.formatDate(item.startDate, "yyyy/MM/dd");
          item.endDate = vueFilter.formatDate(item.endDate, "yyyy/MM/dd");
        });
      }
    },
   async onRefresh() {
      this.getInitData();
    },
    onClickLeft(){
      //刷新页面
      var sendData = JSON.stringify({ handle: "reload_event_detail" });
      this.iJsBridge.call({
        method: "SMGeneral.setResultToNative",
        postData: sendData
      });
       this.iJsBridge.close();
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/servicePersonList.vue